import {
  SELECTED_ACCOUNT_KEY,
  SELECTED_SEEK_ACCOUNT_KEY,
} from 'src/constants/userAccountKeys';
import { getItem } from 'src/utils/localStorage';

/**
 * @deprecated
 * This is getting data arbitrarily from local storage. This is not safe.
 * We should get it from Hirer Graph instead.
 */
export const getAdvertiserIds = () => ({
  advertiserId: getItem(SELECTED_ACCOUNT_KEY),
  seekAdvertiserId: getItem(SELECTED_SEEK_ACCOUNT_KEY),
});

/**
 * @deprecated
 * IDs are arbitrary values that we don't need to know about.
 * Ideally, we should use whatever comes out from Hirer Graph. So, this function is ideally not needed
 */
export const isValidId = (id: string | null): id is string =>
  Boolean(id && parseInt(id, 10) > 0);
